<script setup lang="ts">
  import { computed, inject } from 'vue';
  import { SELECTED_NEW_ROW_KEY } from './fill-context';

  // Its own component so the accessible name follows the selection without re-rendering the
  // whole table, which owns the provided selection.
  const props = defineProps<{ tableId: string; enabled: boolean }>();
  const emit = defineEmits<{ (e: 'remove'): void }>();

  const selectedNewRow = inject(SELECTED_NEW_ROW_KEY, null);
  const label = computed(() =>
    (selectedNewRow?.value ?? null) === null ? 'Remover a última linha nova' : 'Remover a linha selecionada',
  );
</script>

<template>
  <button
    type="button"
    class="flex h-6 w-full items-center justify-center rounded-lg border border-light-gray-xx bg-gray-08 text-sm leading-none shadow-xs"
    :class="props.enabled
      ? 'text-gray-03 hover:bg-gray-02'
      : 'cursor-not-allowed text-gray-16 opacity-50'"
    :data-testid="`fill-table-remove-row-${props.tableId}`"
    :aria-label="props.enabled ? label : 'Remover linha'"
    :disabled="!props.enabled"
    @click="emit('remove')"
  >
    −
  </button>
</template>
